
import TranResourcesApi from './src/Tranresources'
import CarParkRecordApi from './src/CarParkRecordApi'
import CarParkFeeApi from './src/CarParkFeeApi'
import CarParkBigDataApi from './src/BigDataApi'


let apis = {
   TranResourcesApi,
   CarParkRecordApi,
   CarParkFeeApi,
   CarParkBigDataApi
};

export default apis;
